var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkSitelist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64018 0.231773C10.0645 0.585337 10.1218 1.2159 9.76822 1.64018L4.76822 7.64018C4.58836 7.85602 4.32599 7.98624 4.04531 7.99897C3.76464 8.0117 3.49156 7.90577 3.29289 7.7071L0.292893 4.7071C-0.0976311 4.31658 -0.0976311 3.68341 0.292893 3.29289C0.683417 2.90236 1.31658 2.90236 1.70711 3.29289L3.9328 5.51858L8.23178 0.35981C8.58534 -0.0644668 9.21591 -0.121791 9.64018 0.231773Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkSitelist);
export default __webpack_public_path__ + "static/media/icon-checkmark-sitelist.5b118a10838663e1cbcd5b290646e0bc.svg";
export { ForwardRef as ReactComponent };